module.exports = __webpack_public_path__ + "static/assets/490ceab39c68466d22416a8bfe8105f5.png";